import axios from "axios";
import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";

export interface ParamsRequest {
    category: string;
    // list_no?: string;
}
export interface BodyRequest {
    m_name: string;
    m_age: string;
    m_tel: string;
    m_area: string;
    m_car: string;
    m_up: string;
    m_time: string;
    contents: string;
}
type recruitRequest = ParamsRequest & BodyRequest;

export interface recruitResponse {
    statusCode: number;
    message: string;
    data: null;
}

export const usePostRecruit = (
    successCallback?: (data: recruitResponse) => void,
): UseMutationResult<recruitResponse, Error, recruitRequest, unknown> => {
    // const queryClient = useQueryClient();
    return useMutation<recruitResponse, Error, recruitRequest>({
        mutationFn: async (recruitData: recruitRequest) => {
            const url = enum_api_uri.post_recruit.replace(":category", recruitData.category);
            const response = await axios.post(url, recruitData);
            return response.data;
        },
        onSuccess: data => {
            // queryClient.invalidateQueries({ queryKey: [""] });
            successCallback?.(data);
        },
    });
};
